import React from "react";

import Default from "./default/Default";
import Rounded from "./rounded/Rounded";
import RoundedBackground from "./rounded-background/RoundedBackground";
import { DesignContainer } from "./styles";

const designComponents = {
  default: Default,
  rounded: Rounded,
  roundedBackground: RoundedBackground,
};

const Design = ({ data, isPreview = false, canEdit = false, tab }) => {
  const DesignComponent = designComponents[data?.style];

  return (
    <DesignContainer alignment={data.alignment}>
      <DesignComponent
        data={data}
        isPreview={isPreview}
        canEdit={canEdit}
        tab={tab}
      />
    </DesignContainer>
  );
};

export default Design;
